import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
    isShowing: boolean,
    scene: string, ('form', 'publishing')
    podcastName: strung,
    podcastDescription: string,
    podcastItunesCategory: string,
}
*/

const isShowingReducer = (state = false, action) => {
  switch (action.type) {
    case types.SET_IS_SHOWING:
      return action.payload.isShowing;
    default:
      return state;
  }
};

const sceneReducer = (state = 'form', action) => {
  switch (action.type) {
    case types.SET_SCENE:
      return action.payload.scene;
    default:
      return state;
  }
};

const podcastNameReducer = (state = '', action) => {
  switch (action.type) {
    case types.SET_PODCAST_NAME:
      return action.payload.podcastName;
    default:
      return state;
  }
};

const podcastLanguageReducer = (state = '', action) => {
  switch (action.type) {
    case types.SET_PODCAST_LANGUAGE:
      return action.payload.podcastLanguage;
    default:
      return state;
  }
};
const podcastDescriptionReducer = (state = '', action) => {
  switch (action.type) {
    case types.SET_PODCAST_DESCRIPTION:
      return action.payload.podcastDescription;
    default:
      return state;
  }
};
const podcastItunesCategoryReducer = (state = '', action) => {
  switch (action.type) {
    case types.SET_PODCAST_ITUNES_CATEGORY:
      return action.payload.podcastItunesCategory;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isShowing: isShowingReducer,
  scene: sceneReducer,
  podcastName: podcastNameReducer,
  podcastDescription: podcastDescriptionReducer,
  podcastItunesCategory: podcastItunesCategoryReducer,
  podcastLanguage: podcastLanguageReducer,
});

export default reducer;
